var swiper = new Swiper(".offerSlider", {
pagination: {
        el: ".swiper-pagination",
  clickable: true
    },
    spaceBetween: 10,
    // autoplay: true,
    speed: 900,
    loop: true,
    slidesPerView: 1
});
var swiper = new Swiper(".slideshow", {
pagination: {
        el: ".swiper-pagination",
  clickable: true
    },
    spaceBetween: 0,
    // autoplay: true,
    speed: 900,
    loop: true,
    slidesPerView: 1
});

var swiper = new Swiper(".popularProducts", {
        spaceBetween: 5,
        speed: 900,
        loop: true,
        slidesPerView: 4,
        breakpoints: {
        320: {
            slidesPerView: 1,
            spaceBetween: 10,

        },
          414: {
            slidesPerView: 2,
            spaceBetween: 10,

        },

        768: {
            slidesPerView: 3,
            spaceBetween: 10,
        },
          1024: {
            slidesPerView: 4,
            spaceBetween: 10,
        }
    },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });

var swiper = new Swiper(".testimonials", {
        spaceBetween: 18,
  centeredSlides: true,
        speed: 900,
        loop: true,
        slidesPerView: 3,
         breakpoints: {
        320: {
            slidesPerView: 1,
            spaceBetween: 0,

        },
536: {
            slidesPerView: 2,
            spaceBetween: 10,

        },
        768: {
            slidesPerView: 3,
            spaceBetween: 10,
        },
    },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });

var swiper = new Swiper(".collectionSlider", {
    spaceBetween: 10,
    pagination: {
        el: ".swiper-pagination",
        dynamicBullets: true,
        clickable: true
    },
    breakpoints: {
        320: {
            slidesPerView: 1.5,
            spaceBetween: 10,

        },
       576: {
            slidesPerView: 2.5,
            spaceBetween: 10,
        },

        1024: {
            slidesPerView: 3.5,
            spaceBetween: 10,
        },
    },
});

/*------------------Categories   Slider---------------*/

var swiper = new Swiper(".categorySwiper", {

    spaceBetween: 10,
    // autoplay: true,
    speed: 900,
    autoplay: {
      delay: 3000,
    },
    loop: true,
    breakpoints: {
        320: {
            slidesPerView: 2,
            spaceBetween: 20,
        },
        768: {
            slidesPerView: 4.8,
            spaceBetween: 20,
        },

        1024: {
            slidesPerView: 5,
            spaceBetween: 30,
        },
    },
});

/*------------------About card slider---------------*/

var swiper = new Swiper(".cardSlider", {

    spaceBetween: 20,
    breakpoints: {
        320: {
            slidesPerView: 1.2,

        },
        768: {
            slidesPerView: 2.2,

        },

    },
});

// accordion
$( document ).ready(function() {
    document.querySelectorAll('.accordion-header').forEach(button => {
    button.addEventListener('click', () => {
        const accordionContent = button.nextElementSibling;

        button.classList.toggle('active');

        if (button.classList.contains('active')) {
            accordionContent.style.maxHeight = accordionContent.scrollHeight + 'px';
        } else {
            accordionContent.style.maxHeight = 0;
        }

        // Close other open accordion items
        document.querySelectorAll('.accordion-header').forEach(otherButton => {
            if (otherButton !== button) {
                otherButton.classList.remove('active');
                otherButton.nextElementSibling.style.maxHeight = 0;
            }
        });
    });
});

});
